import { SystemStyleObject } from '@chakra-ui/react';

import { ButtonVariants } from '@/components/atoms';

const baseStyle: SystemStyleObject = {
  borderRadius: 10,
  fontWeight: `semibold`,
  border: `1px solid`,
};

const variants: Record<ButtonVariants, SystemStyleObject> = {
  green: {
    color: `hsl(111, 12%, 56%)`,
    background: `transparent`,
    borderColor: `hsl(111, 12%, 56%)`,
  },
  pink: {
    color: `hsl(5, 29%, 74%)`,
    background: `transparent`,
    borderColor: `hsl(5, 29%, 74%)`,
  },
  black: {
    color: `black`,
    backgroundColor: `transparent`,
    borderColor: `black`,
  },
  white: {
    color: `white.main`,
    backgroundColor: `transparent`,
    borderColor: `white.main`,
  },
  /** Mauve du logo */
  purple: {
    color: `primary.purple`,
    background: `transparent`,
    borderColor: `primary.purple`,
  },
  /** Orange du logo */
  orange: {
    color: `primary.orange`,
    background: `transparent`,
    borderColor: `primary.orange`,
  },
  solidOrange: {
    color: `white`,
    background: `primary.orange`,
    borderColor: `primary.orange`,
  },
};

const defaultProps: SystemStyleObject = {};

export const Button = {
  baseStyle,
  variants,
  defaultProps,
};
